import {makeEntityStore} from '../../../helpers/factory';
import {BaseRootEntityService} from '../../../../api';
// Deep import to avoid models barrel → form/validation → FormUtils → @hit/base cycle.
import {FormDefinition} from '../../../../models/hit/form/FormDefinition';
import {formDefinitionSchema} from '../../../../models/hit/form/schema';

export default makeEntityStore({
  modelCls: FormDefinition,
  service: new BaseRootEntityService('form_definition', FormDefinition),
  schema: formDefinitionSchema,
});
